<template>
  <div class="catalogs-content">
    <div v-if="!$route.path.includes('edit') && !$route.path.includes('create')" class="sub-header">
      <b-container fluid>
        <appCatalogsNav
          v-if="$route.name == 'resolutions-catalogs'"
          :title="resolutionsTitle"
          :breadcrumb-last="resolutionsBreadcrumb"
        />
        <appCatalogsNav
          v-else-if="$route.name == 'buildings'"
          :title="buildingsTitle"
          :breadcrumb-last="buildingsBreadcrumb"
        />
        <appCatalogsNav
          v-else-if="$route.name == 'majorities'"
          :title="majoritiesTitle"
          :breadcrumb-last="majoritiesBreadcrumb"
        />
      </b-container>
    </div>

    <router-view />
  </div>
</template>

<script>
import appCatalogsNav from "@/components/snippets/CatalogsNav";

export default {
  components: {
    appCatalogsNav,
  },
  data() {
    return {
      resolutionsTitle: this.$t("catalogs.resolutions_catalogs"),
      resolutionsBreadcrumb: this.$t("catalogs.resolutions"),
      buildingsTitle: this.$t("catalogs.buildings_catalogs"),
      buildingsBreadcrumb: this.$t("catalogs.buildings"),
      majoritiesTitle: this.$t("catalogs.majorities_catalogs"),
      majoritiesBreadcrumb: this.$t("catalogs.majorities"),
    };
  },
};
</script>
